import React, { useState } from "react";

type Props = {
  children: JSX.Element;
};

interface ForgotPasswordContextProps {
  isEmailSent: boolean;
  isCodeVerified: boolean;
  isFirstStep: boolean;
  setIsEmailSent: React.Dispatch<React.SetStateAction<boolean>>;
  setIsCodeVerified: React.Dispatch<React.SetStateAction<boolean>>;
  setIsFirstStep: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ForgotPasswordContext = React.createContext<ForgotPasswordContextProps>({
  isEmailSent: false,
  isCodeVerified: false,
  isFirstStep: true,
  setIsEmailSent: () => null,
  setIsCodeVerified: () => null,
  setIsFirstStep: () => null,
});

const ForgotPasswordContextProvider = ({ children }: Props) => {
  const [isCodeVerified, setIsCodeVerified] = useState<boolean>(false);
  const [isEmailSent, setIsEmailSent] = useState<boolean>(false);
  const [isFirstStep, setIsFirstStep] = useState<boolean>(true);

  return (
    <ForgotPasswordContext.Provider
      value={{
        isCodeVerified,
        isEmailSent,
        isFirstStep,
        setIsCodeVerified,
        setIsFirstStep,
        setIsEmailSent,
      }}
    >
      {children}
    </ForgotPasswordContext.Provider>
  );
};

export const useForgotPasswordContext = () => {
  const context = React.useContext(ForgotPasswordContext);

  if (context === undefined) {
    throw new Error("context must be used within a Forgot Context Provider");
  }

  return context;
};

export default ForgotPasswordContextProvider;
